/**
 * Development auth provider.
 *
 * Surfaces a synthetic admin user so the UI renders without a running
 * identity provider. For production use KeycloakAuthProvider instead.
 */
import { useCallback, useMemo, useState, type ReactNode } from "react";
import { AuthContext } from "./keycloakAuth";
import type { AuthContextValue, AuthUser } from "./keycloakAuth";

const DEV_USER: AuthUser = {
  subject: "local-admin",
  username: "local-admin",
  email: "admin@adapt.local",
  displayName: "Local Admin",
  roles: ["systemAdmin"],
};

export function AuthProvider({ children }: { children: ReactNode }): React.JSX.Element {
  const [user] = useState<AuthUser | null>(DEV_USER);

  const getToken = useCallback(async (): Promise<string> => "dev-token", []);
  const hasRole = useCallback((role: string): boolean => user?.roles.includes(role) ?? false, [user]);
  const login = useCallback(async () => {}, []);
  const logout = useCallback(async () => {}, []);

  const value = useMemo<AuthContextValue>(
    () => ({
      initialized: true,
      authenticated: true,
      error: null,
      user,
      getToken,
      hasRole,
      login,
      logout,
    }),
    [user, getToken, hasRole, login, logout],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
